import BuildingType from "@/roc/building/BuildingType";
import BuildingMaxLevel from "@/roc/building/BuildingMaxLevel";
import Effects from '@/roc/effects/Effects';
import WorkshopProduction from '@/roc/effects/Production/WorkshopProduction';
import {getIcon, WorkshopProductionGroup} from '@/roc/building/workshop/WorkshopOutput';
import EraType from '@/roc/era/EraType';
import Happiness from '@/roc/effects/CultureBonus/Happiness';

const Glassblower = {
  id: "128",
  name: "Glassblower",
  width: 4,
  height: 3,
  type: BuildingType.WORKSHOP_3,
  era: "earlyGothicEra",
  icon: getIcon(WorkshopProductionGroup.Glassblower),
  minLevel: 1,
  maxLevel: BuildingMaxLevel.WORKSHOP_3,
  url: 'https://riseofcultures.wiki.gg/wiki/Home_Cultures/Workshops/Glassblower',
  flags: 0,
  counts: {
    stoneAge: null,
    bronzeAge: null,
    minoanEra: null,
    classicGreece: null,
    earlyRome: null,
    romanEmpire: null,
    byzantineEra: null,
    ageOfTheFranks: null,
    feudalAge: null,
    iberianEra: null,
    kingdomOfSicily: null,
    highMiddleAges: null,
    earlyGothicEra: 3,
    lateGothicEra: 3,
  },
  effects: Effects.create([
    new WorkshopProduction(WorkshopProductionGroup.Glassblower, EraType.earlyGothicEra),
    new WorkshopProduction(WorkshopProductionGroup.Glassblower, EraType.lateGothicEra),
    new Happiness({
      stoneAge: null,
      bronzeAge: null,
      minoanEra: null,
      classicGreece: null,
      earlyRome: null,
      romanEmpire: null,
      byzantineEra: null,
      ageOfTheFranks: null,
      feudalAge: null,
      iberianEra: null,
      kingdomOfSicily: null,
      highMiddleAges: null,
      earlyGothicEra: [1260, 2520, 5040],
      lateGothicEra: [1500, 3000, 6000],
    }),
  ]),
};

export default Glassblower;
